import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/users")({
  component: () => (
    <div className="rounded-xl border border-border bg-card p-6">
      <h2 className="text-base font-medium">Users</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Search users, grant platform admin, impersonate. Coming in the next release.
      </p>
    </div>
  ),
});
